var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-body flex"},[_c('el-tree',{attrs:{"data":_vm.data,"show-checkbox":"","node-key":"id","default-expanded-keys":[2, 3],"default-checked-keys":[5],"props":_vm.defaultProps}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f022d4bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/18/Tree/index.vue
// module id = LZrj
// module chunks = 0